import { createClient, SupabaseClient } from '@supabase/supabase-js'

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY

let client: SupabaseClient | null = null
if (SUPABASE_URL && SUPABASE_ANON_KEY) {
  try {
    client = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
  } catch (err) {
    // A malformed REACT_APP_SUPABASE_URL (missing https://, trailing
    // whitespace, swapped fields) would otherwise throw at module init and
    // whitescreen the entire app. Warn and fall back to the localStorage path.
    console.warn(
      '[supabase] createClient failed — falling back to localStorage. ' +
        'Check that REACT_APP_SUPABASE_URL starts with https:// and that ' +
        'the anon key wasn’t pasted into the wrong field.',
      err,
    )
  }
}

export const supabase = client
export const supabaseEnabled = client !== null
